import React from "react";
import "./SingleNetworkProfile.css";
import { Col, Container, Row, Tab, Tabs } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import CamplaCoreService from "../../services/CamplaCoreService";
import StorageService from "../../services/StorageService";
import APIErrorHelper from "../../helpers/APIErrorHelper";
import EditNetworkProfileDialog from "./dialogs/editTemplateDialog/EditNetworkProfileDialog";
import NetworkProfileInfoCard from "./networkProfileInfoCard/NetworkProfileInfoCard";
import DescriptionTab from "../../components/descriptionTab/DescriptionTab";
import UnsavedChangesDialog from "../../components/dialogs/unsavedChangesDialog/UnsavedChangesDialog";
import AllowedUrlsTab from "./tabs/allowedUrlsTab/AllowedUrlsTab";

class SingleNetworkProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      networkProfile: null,
      cloudProfiles: [],
      apiError: "",
      dialogApiError: "",
      showEditDialog: false,
      showUnsavedChangesDialog: false,
      isSaving: false
    };

    this.fetchData = this.fetchData.bind(this);
    this.onSubmitNetworkProfile = this.onSubmitNetworkProfile.bind(this);
    this.onEdit = this.onEdit.bind(this);
    this.onHideEditDialog = this.onHideEditDialog.bind(this);
  }

  async componentDidMount() {
    const cachedNetworkProfile = StorageService.getReferenceType(
      "singleNetworkProfile"
    );
    const cachedCloudProfiles = StorageService.getReferenceType(
      "cloudProfiles"
    );
    if (
      cachedNetworkProfile &&
      cachedNetworkProfile._id === this.props.match.params.id
    ) {
      this.setState({ networkProfile: cachedNetworkProfile });
    }
    if (cachedCloudProfiles)
      this.setState({ cloudProfiles: cachedCloudProfiles });
    await this.fetchData();
  }

  onEdit() {
    this.setState({ showEditDialog: true });
  }

  async fetchData() {
    try {
      const networkProfile = await CamplaCoreService.getNetworkProfile(
        this.props.match.params.id
      );
      const cloudProfiles = await CamplaCoreService.getAllCloudNetworkProfiles();
      StorageService.set("networkProfile", networkProfile);
      StorageService.set("cloudProfiles", cloudProfiles);

      this.setState({
        networkProfile,
        cloudProfiles
      });
    } catch (err) {
      await this.setState({
        apiError: APIErrorHelper.getError(
          err,
          () => this.setState({ apiError: "" }),
          {},
          this.props.t
        )
      });
    }
  }

  async onSubmitNetworkProfile(changedNetworkProfile) {
    try {
      const updatedNetworkProfile = await CamplaCoreService.updateNetworkProfile(
        this.state.networkProfile._id,
        changedNetworkProfile
      );
      StorageService.set("singleNetworkProfile", updatedNetworkProfile);
      this.setState({
        networkProfile: updatedNetworkProfile,
        showEditDialog: false
      });
      return true;
    } catch (err) {
      this.setState({
        dialogApiError: APIErrorHelper.getError(
          err,
          () => this.setState({ dialogApiError: "" }),
          {
            PRECONDITION_FAILED:
              "SingleInstanceTemplate.APIError.PreconditionFailed",
            NOT_FOUND: "SingleInstanceTemplate.APIError.NotFound",
            CONFLICT: "SingleInstanceTemplate.APIError.UpdateConflict"
          },
          this.props.t
        )
      });
    }
    return false;
  }

  onHideEditDialog(isFormDirty, callback) {
    if (isFormDirty) {
      this.setState({
        showUnsavedChangesDialog: true,
        closeAction: () => {
          this.setState({
            showEditDialog: false
          });
          callback();
        }
      });
    } else {
      this.setState({
        showEditDialog: false
      });
      callback();
    }
  }

  render() {
    const { t } = this.props;

    return !this.state.networkProfile ? (
      <div />
    ) : (
      <div>
        <Container className="mt-3">
          {this.state.apiError ? (
            <Row>
              <Col>{this.state.apiError}</Col>
            </Row>
          ) : (
            ""
          )}
          <UnsavedChangesDialog
            show={this.state.showUnsavedChangesDialog}
            onHide={() => this.setState({ showUnsavedChangesDialog: false })}
            onSubmit={() => {
              this.setState({ showUnsavedChangesDialog: false });
              this.state.closeAction();
            }}
          />
          <EditNetworkProfileDialog
            show={this.state.showEditDialog}
            networkProfile={this.state.networkProfile}
            cloudProfiles={this.state.cloudProfiles}
            dialogApiError={this.state.dialogApiError}
            onHide={this.onHideEditDialog}
            onSubmit={async networkProfile => {
              this.setState({ isSaving: true });
              await this.onSubmitNetworkProfile(networkProfile);
              this.setState({ isSaving: false });
            }}
            isSaving={this.state.isSaving}
          />
          <Row>
            <Col>
              <NetworkProfileInfoCard
                networkProfile={this.state.networkProfile}
                cloudProfiles={this.state.cloudProfiles}
                onEdit={this.onEdit}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              {this.state.networkProfile &&
                this.state.cloudProfiles && (
                  <Tabs defaultActiveKey="1">
                    <Tab
                      eventKey="1"
                      tabClassName="item-link"
                      title={t("SingleNetworkProfile.DescriptionTabTitle")}
                    >
                      <DescriptionTab
                        text={this.state.networkProfile.description}
                        lang={this.props.i18n.language}
                      />
                    </Tab>
                    <Tab
                      eventKey="2"
                      tabClassName="item-link"
                      title={t("SingleNetworkProfile.AllowedUrlsTab.Title")}
                    >
                      <AllowedUrlsTab
                        dialogApiError={this.state.dialogApiError}
                        networkProfile={this.state.networkProfile}
                        onSubmit={this.onSubmitNetworkProfile}
                      />
                    </Tab>
                  </Tabs>
                )}
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default withTranslation()(SingleNetworkProfile);
